export default "__VITE_ASSET__DrZNYjzd__"